module.exports = __webpack_public_path__ + "img/arrow_diagonal_up_right_blue.99af3b05.svg";